<template>
  <div class="chatter-feed-filter" role="tablist" aria-label="Chatter feed filter">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      role="tab"
      class="chatter-feed-filter__tab"
      :class="{ 'chatter-feed-filter__tab--active': value === tab.value }"
      :aria-selected="value === tab.value ? 'true' : 'false'"
      :data-testid="`chatter-feed-filter-${tab.value}`"
      @click="select(tab.value)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  value: {
    type: String,
    default: "all",
  },
});

const emit = defineEmits(["update:value", "change"]);

const tabs = [
  { value: "all", label: "All" },
  { value: "comments", label: "Comments" },
  { value: "history", label: "History" },
];

const activeValue = computed(() => props.value || "all");

function select(value) {
  if (value === activeValue.value) return;
  emit("update:value", value);
  emit("change", value);
}
</script>

<style scoped>
.chatter-feed-filter {
  display: flex;
  gap: 4px;
  width: 552px;
  height: 44px;
  padding: 4px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  background: #f9fafb;
  box-sizing: border-box;
}

.chatter-feed-filter__tab {
  flex: 1;
  height: 36px;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #667085;
  cursor: pointer;
}

.chatter-feed-filter__tab--active {
  background: #ffffff;
  color: #344054;
  box-shadow: 0px 1px 2px 0px #1018280d;
}

.chatter-feed-filter__tab:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 2px;
}
</style>
